import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ActiveObject, resolve } from '../../Container';
import { ShortcutRegistry } from '../../ShortcutRegistry';
import { EditorSession } from '../EditorSession';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { ToolboxController } from './ToolboxController';
import { ToolboxItem } from './ToolboxItem';
import { toolEquip } from './ToolCommands';
import { ToolInfo } from './ToolInfo';
import { ToolManager, ToolRecord } from './ToolManager';

export class ToolShortcutMechanics extends ActiveObject {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(EditorSession) private session!: EditorSession;
    @resolve(ShortcutRegistry) private shortcuts!: ShortcutRegistry;
    @resolve(ToolManager) private tools!: ToolManager;
    @resolve(ToolboxController) private toolbox!: ToolboxController;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start() {
        this.burden(
            this.tools.observe(this.realizeToolShortcuts),
            this.toolbox.observe(this.realizeToolboxShortcuts),
        );
        this.realizeToolShortcuts();
        this.realizeToolboxShortcuts();
    }

    private realizeToolShortcuts = () => {
        this.shortcuts.unregisterPartial('tools:');
        for (const t of this.tools) {
            if (!t.shortcut) continue;
            this.shortcuts.register(`tools:${t.id}`, t.shortcut, () => this.onToolShortcut(t));
        }
    };

    private realizeToolboxShortcuts = () => {
        this.shortcuts.unregisterPartial('toolbox:');
        for (const tm of this.toolbox) {
            if (!tm.shortcut) continue;
            this.shortcuts.register(`toolbox:${tm.id}`, tm.shortcut, () => this.onToolboxShortcut(tm));
        }
    };

    private onToolShortcut(tool: ToolRecord) {
        const prev = this.session.get(ToolInfo);
        this.dispatch(toolEquip, [tool.id]);
        const next = this.session.get(ToolInfo);
        // Do this because sometimes toolEquip will override our request, so check it actually was equipped and remained equipped before
        // opening the widget.
        if (prev.id === next.id && next.id === tool.id) {
            this.toolbox.openWidgetForTool(tool.id);
        }
    }

    private onToolboxShortcut(item: ToolboxItem) {
        this.toolbox.openWidget(item.id);
    }
}
